import css from "./style.module.css";
import css2 from "../Form.module.css";
import 'react-calendar/dist/Calendar.css';
import { useRef, useEffect, useState } from "react";

const DateTime = ({ children, onChange }) => {
    const dateRef = useRef();
    const hrRef = useRef();
    const minRef = useRef();

    const { label, required, value } = children;
    const [localValue, setLocalValue] = useState(value ? new Date(value) : null);

    // This effect synchronizes the local state with the prop value
    useEffect(() => {
        setLocalValue(value ? new Date(value) : null);
    }, [value]);

    // This effect populates the input fields from the local state
    useEffect(() => {
        if (localValue) {
            // Populate inputs from the local time date object
            const year = localValue.getFullYear();
            const month = String(localValue.getMonth() + 1).padStart(2, "0");
            const day = String(localValue.getDate()).padStart(2, "0");
            const hours = String(localValue.getHours()).padStart(2, "0");
            const minutes = String(localValue.getMinutes()).padStart(2, "0");
            
            dateRef.current.value = `${year}-${month}-${day}`;
            hrRef.current.value = hours;
            minRef.current.value = minutes;
        } else {
            // Clear inputs if no value exists
            dateRef.current.value = "";
            hrRef.current.value = "";
            minRef.current.value = "";
        }
    }, [localValue]);

    const valChange = () => {
        const date = dateRef.current.value;
        const hr = hrRef.current.value;
        const min = minRef.current.value;

        // Ensure all inputs have valid values before creating the date object
        const hrVal = parseInt(hr, 10);
        const minVal = parseInt(min, 10);

        if (date && hr && min && !isNaN(hrVal) && !isNaN(minVal)) {
            // Create a new Date object using local time to avoid timezone issues
            const newDate = new Date(date);
            newDate.setHours(hrVal);
            newDate.setMinutes(minVal);
            
            // Format the date string without any timezone offset.
            // This matches the format expected by java.time.LocalDateTime.
            const localFormattedString = `${newDate.getFullYear()}-${String(newDate.getMonth() + 1).padStart(2, "0")}-${String(newDate.getDate()).padStart(2, "0")}T${String(newDate.getHours()).padStart(2, "0")}:${String(newDate.getMinutes()).padStart(2, "0")}:00`;
            
            setLocalValue(newDate);
            onChange && onChange(localFormattedString);
        } else {
            setLocalValue(null);
            onChange && onChange(null);
        }
    };

    const validate = (e) => {
        const targetValue = parseInt(e.target.value, 10);
        if (isNaN(targetValue) || targetValue < 0) {
            e.target.value = 0;
        }
        if (e.target.value > parseInt(e.target.max)) {
            e.target.value = parseInt(e.target.max);
        }
        valChange();
    };

    return (
        <div className={css2.FormControl}>
            <label className={css.Label}>{label}</label>

            <div className={css.DateTime}>
                <input
                    onChange={valChange}
                    ref={dateRef}
                    type="date"
                    required={required}
                    className={css.Input}
                />

                <div className={css.TimeGroup}>
                    <input
                        ref={hrRef}
                        onChange={validate}
                        placeholder="HH"
                        max={23}
                        type="number"
                        required={required}
                        className={css.Input}
                    />
                    <span className={css.Separator}>:</span>
                    <input
                        ref={minRef}
                        onChange={validate}
                        placeholder="MM"
                        max={59}
                        type="number"
                        required={required}
                        className={css.Input}
                    />
                </div>
            </div>
        </div>
    );
};

export default DateTime;
